import { FilterOutlined } from "@ant-design/icons"
import { RightEnum } from "@finway-group/shared/lib/models"
import { Button } from "antd"
import React, { useCallback } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import SearchInput from "~Components/searchInput"
import { useCostCenters } from "~Shared/hooks/costCenter.hooks"
import { useEmployees } from "~Shared/hooks/employee.hooks"
import { useExpenseTags } from "~Shared/hooks/expenseTags.hooks"
import { useTableSearchString } from "~Shared/hooks/table.hooks"
import { useUserCreditors } from "~Shared/hooks/vendor.hooks"
import { AuthzService } from "~Shared/services"
import { updateTableSearch } from "~Shared/store/actions/tables/tableActions"
import { TablesEnum } from "~Shared/store/reducers/tableConfigReducer"
import useStateIfMounted from "~Shared/utils/hooks/useStateIfMounted"
import { FilterSectionLegacy } from "./filter/FilterSectionLegacy"

interface TableButtonsProps {
    table: TablesEnum
    onSearch?: (searchString: string) => void
    injectFilterModal: (isVisible: boolean, onCancel: (flag: boolean) => void) => any
    setIsShowingModal?: (isShowingModal: boolean) => void
    additionalButtons?: any
}

const TableButtons = ({ table, onSearch, injectFilterModal, additionalButtons = <></> }: TableButtonsProps) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const [isFilterModalShowing, setIsFilterModalShowing] = useStateIfMounted<boolean>(false)
    const searchString = useTableSearchString(table)
    const employees = useEmployees({ excludeDeleted: true })
    const userCreditors = useUserCreditors(AuthzService.isRightGrantedForLoggedInUser(RightEnum.EMPLOYEE__ALL__READ))
    const costCenters = useCostCenters(true)
    const expenseTags = useExpenseTags()

    const searchCallback = useCallback(
        async (value: string) => {
            if (onSearch) {
                onSearch(value)
            } else {
                dispatch(updateTableSearch(table, value))
            }
        },
        [dispatch, onSearch, table],
    )

    return (
        <>
            <div className="flex btn-wrapper mt-20 justify-end">
                {injectFilterModal(isFilterModalShowing, setIsFilterModalShowing)}
                <SearchInput onSearch={searchCallback} value={searchString} />
                <Button className="w-100" onClick={() => setIsFilterModalShowing(true)}>
                    <FilterOutlined />
                    {t("action:filter")}
                </Button>
                {additionalButtons}
            </div>
            <FilterSectionLegacy table={table} options={{ employees, userCreditors, costCenters, expenseTags }} />
        </>
    )
}

export default TableButtons
